module.exports = __webpack_public_path__ + "static/media/background2.8e58c9d0.jpg";